export const dataText = {
  en: {
    title: 'ATTENTION',
    text: 'Confirm your email to continue with the process',
    buttonTitle: "CLOSE"
  },
  es: {
    title: 'ATENCION',
    text: 'Confirmar su email para continuar con el proceso',
    buttonTitle: "CERRAR"
  },
  pt: {
    title: 'ATENÇÃO',
    text: 'Confirme seu e-mail para continuar com o processo',
    buttonTitle: "FECHAR"
  }
};
